import { render } from "./KpiSearch.vue?vue&type=template&id=be9175e0"
import script from "./KpiSearch.vue?vue&type=script&lang=js"
export * from "./KpiSearch.vue?vue&type=script&lang=js"

import exportComponent from "D:\\fz\\1_Task\\hr.haite.sg\\orangehrm-5.2\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__